import styled from 'styled-components'

import { useHapticFeedback } from '@blade/ui-kit'
import { useTranslation } from '@root/shared/localization'
import { Drawer } from '@root/shared/ui-kit'

import type { DrawerControlProps } from '@root/shared/ui-kit'

type PremiumScreenActiveDrawerProps = {} & DrawerControlProps

export const PremiumScreenActiveDrawer: React.FC<
  PremiumScreenActiveDrawerProps
> = ({ open, onOpenChange }) => {
  const { t } = useTranslation()
  const haptics = useHapticFeedback()

  const handleClose = () => {
    haptics.impactOccurred('light')
    onOpenChange?.(false)
  }

  return (
    <Root open={open} onOpenChange={handleClose}>
      {t('premium.purchased.tab.active')}
    </Root>
  )
}

const Root = styled(Drawer)`
  background-color: var(--background-1);
  height: var(--max-drawer-height);
`
